import Logger from '../Log'
import FillMethod from './FillMethod'
import { ecpmOrDefault, loadScript, playerDims } from '../utils'

const Log = Logger.for('AvantisFillMethod')

export class AvantisFillMethod extends FillMethod {
  constructor (bidder) {
    super('avantis', bidder, 'video', ecpmOrDefault(bidder.params.ecpm, 1))
  }

  fill (slot, media) {
    return new Promise((resolve, reject) => {
      const url = 'https://cdn.avantisvideo.com/avm/js/video-loader.js?id=d3942574-ad79-43d5-9575-d9aee573b434&tagId=' +
        this._bidder.params.tagId

      const dims = playerDims(media, { vastXml: '<vast>' })
      slot.node().style.width = dims[0] + 'px'
      slot.node().style.height = (dims[1] + 20) + 'px'

      loadScript(url, slot.node(), { id: 'avantisJS' })
        .then((s) => {
          Log.debug('Avantis script loaded')

          slot.resource(s)
          setTimeout(() => {
            if (document.getElementById('avntsPlayer0Wrapper')) {
              Log.info('Avantis loaded content')

              return resolve({
                width: dims[0],
                height: dims[1],
                cpm: this.estValue()
              })
            } else {
              Log.warn('Avantis script didnt load any content')
              slot.resetNode()
              return resolve({ cpm: 0 })
            }
          }, 2000)
        })
    })
  }
}
